import Backdrop, { type BackdropOwnProps } from '@mui/material/Backdrop';
import EnvoriaLoadingIcon from 'components/v2/EnvoriaLoadingIcon';

function FullPageLoadingIndicator({
   open = true,
   children = null,
   invisible = false,
   ...restOfProps
}: Readonly<Omit<BackdropOwnProps, 'open'> & { open?: boolean }>) {
   return (
      <Backdrop
         invisible={invisible}
         open={open}
         sx={[
            (theme) => ({
               zIndex: theme.zIndex.modal + 1,
               backgroundColor: invisible ? 'inherit' : undefined,
            }),
         ]}
         {...restOfProps}
      >
         <EnvoriaLoadingIcon />
         {children}
      </Backdrop>
   );
}

export default FullPageLoadingIndicator;
